import React from "react"
import { BrowserRouter as Router, Route } from "react-router-dom"
import styled, { ThemeProvider } from "styled-components"
import { AppStateStore } from "./_shared/context/AppStateStore"
import dayjs from "dayjs"
import "dayjs/locale/it"

import RoutedApp from "./RoutedApp"

import "./app.css"

// ----------------------------------------------------------------------------
//dayjs config

dayjs.locale("it")

// ----------------------------------------------------------------------------

const App = (props) => {
  const initialState = {
    user: null,
    colors: "dark",
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case "SIGN_IN_FULFILLED": {
        return {
          ...state,
          token: action.payload.token,
          user: action.payload.user,
        }
      }

      case "SIGN_OUT": {
        return {
          ...state,
          user: null,
          token: null,
        }
      }

      case "REFRESH_USER_UNREADED_MESSAGES": {
        return {
          ...state,
          user: {
            ...state.user,
            unreadedMessages: action.payload,
          },
        }
      }

      default: {
        return {
          ...state,
        }
      }
    }
  }

  const appTheme = {
    screenSizes: {
      mobile: 850,
    },

    shadows: {
      cardBoxShadow: "2px 2px 4px rgba(25,25,25,.1)",
      iconBoxShadow: "2px 2px 4px rgba(0,0,0,.1)",
      insetCardBoxShadow: "inset 2px 2px 4px 0 rgba(25,25,25,.1)",
    },
    colors: {
      primaryColor: "#00569d",
      successColor: "#31d158",
      warningDarkColor: "#ff3b30",
      warningLightColor: "#ff453a",

      sidebarColor: "#FFFFFF",

      primaryBackgroundColor: "#f2f6fa",
      secondaryBackgroundColor: "#FFFFFF",
      tertiaryBackgroundColor: "rgb(220,229,238)",

      hoverPrimaryColor: "rgba(236,231,254, .8)",
      hoveredTertiaryBackgroundColor: "rgba(220,229,238,.6)",
      hoverActiveClearer: "rgba(255,255,255, .2)",

      textPrimaryColor: "#333333",
      textSecondaryColor: "rgb(122 ,135 ,150)",
      textOnPrimary: "#FFFFFF",
      placeholderColor: "rgb(122 ,135 ,150)",

      iconColor: "rgb(122 ,135 ,150)",

      borderColor: "rgb(122 ,135 ,150)",
    },
  }

  return (
    <AppStateStore
      initialState={initialState}
      reducer={reducer}
      storeKey="vebi"
    >
      <ThemeProvider theme={appTheme}>
        <RoutedApp />
      </ThemeProvider>
    </AppStateStore>
  )
}

// ----------------------------------------------------------------------------
// Styled wrapper
// ----------------------------------------------------------------------------

const StyledApp = styled(App)`
  & {
    * {
      color: ${(props) => props?.theme?.colors?.textPrimaryColor};
    }
  }
`

export default StyledApp
